import { BrowserRouter, Routes, Route, Navigate, useLocation} from "react-router-dom";
import Navbar from './pages/Navbar/Navbar'
import Footer from './sections/Footer/Footer'
import ModalForm from './pages/Contact/ModalForm'
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Home from './pages/Home/Home'
// import { MissionPage, PurposePage, ValuePropositionPage, VisionPage } from './navigations/About/Aboutpage/Aboutsubpages';
import AboutPage from './navigations/About/Aboutpage/Aboutpage';
import LeadershipPage from "./navigations/About/LeadershipPage/LeadershipPage";
import ServicesPage from "./navigations/Services/ServicesPage/ServicesPage";
import AIAdvisory from "./navigations/Services/AIAdvisory/AIAdvisory";
import DigitalAdvisory from "./navigations/Services/DigitalAdvisory/DigitalAdvisory";
import DataAdvisory from "./navigations/Services/DataAdvisory/DataAdvisory";
import ITAdvisory from "./navigations/Services/ITAdvisory/ITAdvisory";
import GCCAdvisory from "./navigations/Services/GCCAdvisory/GCCAdvisory";

import MissionPage from "./navigations/About/MissionPage/MissionPage"
import PurposePage from "./navigations/About/PurposePage/PurposePage"
import ValuePropositionPage from "./navigations/About/ValuePropositionPage/ValuePropositionPage"
import VisionPage from "./navigations/About/VisionPage/VisionPage"
import Opportunities from "./navigations/Opportunities/Opportunities";
import AiAdvisory from "./navigations/Services/AIAdvisory/AIAdvisory";
import AdvisoryPartnerForm from "./navigations/Opportunities/AdvisoryPartnerForm/AdvisoryPartnerForm";
import BusinessPartnerForm from "./navigations/Opportunities/BusinessPartnerForm/BusinessPartnerForm";
import DeliveryPartnerForm from "./navigations/Opportunities/DeliveryPartnerForm/DeliveryPartnerForm";
import EmployeePartnerForm from "./navigations/Opportunities/EmployeePartnerForm/EmployeePartnerForm";
import Blogs from "./navigations/Insights/Blogs/Blogs";
import Insights from "./navigations/Insights/Insights";
import CaseStudies from "./navigations/Insights/CaseStudies/CaseStudies";
import Whitepapers from "./navigations/Insights/Whitepapers/Whitepapers";
import AIReadiness from "./navigations/Solutions/AIReadiness";
import Solutions from "./navigations/Solutions/Solutions";
import DigitalTransformation from "./navigations/Solutions/DigitalTransformation";
import OperatingModel from "./navigations/Solutions/OperatingModel";
import ProcessOptimization from "./navigations/Solutions/ProcessOptimization";
import TechnologyAssessment from "./navigations/Solutions/TechnologyAssessment";
import GlobalReach from "./navigations/Globle/GlobalReach";
import Admin from "./Admin/AdminPage/Admin";
import Dashboard from "./Admin/Dashboard/Dashboard";
import Applications from "./Admin/Applications/Applications";




const App = () => {
  const location = useLocation();

  const isAdminRoute =
    location.pathname.startsWith("/admin");
  return (
    <>
      {/* <Navbar /> */}
        {!isAdminRoute && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<ModalForm />} />
        <Route path="/global-reach" element={<GlobalReach />} />


        <Route path="/" element={<Navigate to="/about/vision" replace />} />
        {/* About section — layout wrapper + nested routes */}
        <Route path="/about" element={<AboutPage />}>
          <Route index element={<Navigate to="vision" replace />} />
          <Route path="vision" element={<VisionPage />} />
          <Route path="mission" element={<MissionPage />} />
          <Route path="purpose" element={<PurposePage />} />
          <Route path="value-proposition" element={<ValuePropositionPage />} />
          <Route path="leadership" element={<LeadershipPage />} />

        </Route>

        <Route path="/" element={<Navigate to="/approach/ai-strategy" replace />} />
        {/* About section — layout wrapper + nested routes */}
        <Route path="/approach" element={<ServicesPage />}>
          <Route index element={<Navigate to="ai-strategy" replace />} />
          <Route path="ai-strategy" element={<AIAdvisory />} />
          <Route path="digital-transformation" element={<DigitalAdvisory />} />
          <Route path="data-strategy" element={<DataAdvisory />} />
          <Route path="it-operations" element={<ITAdvisory />} />
          <Route path="gcc-advisory" element={<GCCAdvisory />} />
        </Route>


        <Route path="/" element={<Navigate to="/insights/advisory-partner" replace />} />
        {/* About section — layout wrapper + nested routes */}
        <Route path="/insights" element={<Opportunities />}>
          <Route index element={<Navigate to="advisory-partner" replace />} />
          <Route path="advisory-partner" element={<AdvisoryPartnerForm />} />
          <Route path="delivery-partner" element={<DeliveryPartnerForm />} />
          <Route path="business-partner" element={<BusinessPartnerForm />} />
          <Route path="employee-partner" element={<EmployeePartnerForm />} />
        </Route>




        <Route path="/" element={<Navigate to="/thinking/blogs" replace />} />
        {/* About section — layout wrapper + nested routes */}
        <Route path="/thinking" element={<Insights />}>
          <Route index element={<Navigate to="blogs" replace />} />
          <Route path="blogs" element={<Blogs />} />
          <Route path="whitepapers" element={<Whitepapers />} />
          <Route path="case-studies" element={<CaseStudies />} />
        </Route>


        <Route path="/" element={<Navigate to="/impact/ai-readinessy" replace />} />
        {/* About section — layout wrapper + nested routes */}
        <Route path="/impact" element={<Solutions />}>
          <Route index element={<Navigate to="ai-readiness" replace />} />
          <Route path="ai-readiness" element={<AIReadiness />} />
          <Route path="technology-assessment" element={<TechnologyAssessment />} />
          <Route path="operating-model" element={<OperatingModel />} />
          <Route path="process-optimization" element={<ProcessOptimization />} />
          <Route path="dt-roadmap" element={<DigitalTransformation />} />
        </Route>

        <Route path="/admin/*" element={<Admin />} />

      </Routes>
      <Footer />
      <ToastContainer />
    </>
  )
}


export default App